export default {
	'please-select-an-item': 'Por favor seleccione un artículo'
}